import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/portfolioData";

const SERVICES_STRIP = ["Interior", "Exterior", "Aerial Drone", "Twilight", "MLS-Ready"];

const Testimonials = () => {
  return (
    <section data-testid="testimonials-section-container" className="bg-[#0E0E12] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="eyebrow-label mb-4">04 · Word on the Coast</p>
          <h2 className="font-display max-w-2xl text-2xl font-bold tracking-tight text-zinc-50 sm:text-3xl lg:text-4xl">
            What agents say about the work
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              data-testid="testimonial-card-item"
              className="luxury-card flex flex-col p-8"
            >
              <Quote size={22} className="text-[#D4AF37]" />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-zinc-300">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 border-t border-white/[0.07] pt-5">
                <div className="font-display text-sm font-semibold text-zinc-50">{t.name}</div>
                <div className="mt-1 text-xs text-zinc-500">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          data-testid="brokerage-logos-strip"
          className="mt-16 flex flex-wrap items-center justify-center gap-x-12 gap-y-4 border-t border-white/[0.07] pt-10"
        >
          {SERVICES_STRIP.map((s) => (
            <span key={s} className="font-display text-sm font-bold uppercase tracking-[0.2em] text-zinc-600">
              {s}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
